const getSimpleRequestId = (actionName, id) => `${actionName}_${id}`;

export default getSimpleRequestId;